var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopSavedImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 122,
    opacity: 0.8,
    viewBox: "0 0 378 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43156 30.9202C0.289255 42.4659 -2.30589 56.8835 2.665 67.7404C12.809 89.886 42.4733 94.4165 57.5985 75.6603C62.2197 69.9268 66.8443 63.508 73.8173 61.1399C86.8273 56.7258 100.064 64.1488 113.221 57.2159C127.242 49.8272 137.105 34.5563 153.465 31.6912C163.379 29.9537 172.327 33.6584 181.826 32.644C186.557 32.1402 191.422 31.0744 195.169 28.1443C205.032 20.4266 202.769 4.56618 196.701 -4.55662C191.939 -11.7123 184.812 -17.0962 176.996 -20.6809C159.21 -28.8407 138.95 -24.5295 120.29 -22.1956C109.107 -20.7974 98.3701 -18.5458 87.2421 -17.1407C74.8629 -15.5814 62.5317 -13.1037 50.8415 -8.65537C34.9449 -2.61006 20.142 7.33866 10.639 21.441C8.76377 24.2237 6.9811 27.4417 5.43156 30.9236V30.9202Z",
    fill: "#67CFEE"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.617 49.0727C310.943 48.0514 311.186 47.013 311.351 45.9609L309.427 47.8835L305.776 51.5333L302.125 55.1831L298.474 58.8329L294.823 62.4827L294.031 63.2744C294.477 63.2058 294.923 63.1202 295.365 63.0242C296.668 62.7329 297.946 62.3182 299.184 61.7733L300.298 60.6595L303.949 57.0097L307.6 53.3599L309.842 51.1152C310.137 50.447 310.394 49.7649 310.613 49.0761L310.617 49.0727Z",
    fill: "#FFDE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M309.427 40.5868L305.776 44.2366L302.125 47.8864L298.474 51.5362L294.823 55.186L291.172 58.8358L287.521 62.4856L286.859 63.147C287.381 63.2464 287.902 63.3252 288.426 63.3869C288.995 63.452 289.568 63.4932 290.14 63.5137L292.996 60.659L296.647 57.0092L300.298 53.3594L303.949 49.7096L307.6 46.0598L311.251 42.41L311.587 42.0741C311.553 40.9741 311.429 39.8774 311.22 38.791L309.427 40.5834V40.5868Z",
    fill: "#FFDE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.78 36.9401L302.129 40.59L298.478 44.2397L294.827 47.8896L291.176 51.5394L287.525 55.1892L283.874 58.839L281.422 61.2893C282.255 61.7108 283.109 62.0741 283.983 62.3791L285.697 60.6656L289.348 57.0158L292.999 53.366L296.65 49.7162L300.301 46.0664L303.952 42.4166L307.604 38.7668L310.449 35.9223C310.147 35.0518 309.784 34.1951 309.359 33.3623L305.78 36.9401Z",
    fill: "#FFDE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.78 29.6452L302.129 33.295L298.478 36.9448L294.827 40.5946L291.176 44.2444L287.524 47.8942L283.873 51.544L280.222 55.1939L277.075 58.3399C277.734 58.9225 278.419 59.4537 279.129 59.9369L282.046 57.0205L285.697 53.3706L289.348 49.7208L292.999 46.0711L296.65 42.4212L300.301 38.7714L303.952 35.1216L307.603 31.4718L308.001 31.0743C307.518 30.3649 306.986 29.6795 306.404 29.0215L305.776 29.6486L305.78 29.6452Z",
    fill: "#FFDE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M302.129 25.9947L298.478 29.6445L294.827 33.2943L291.176 36.9441L287.525 40.5939L283.874 44.2437L280.223 47.8935L276.571 51.5434L273.651 54.4632C274.134 55.1726 274.669 55.8546 275.248 56.5126L278.395 53.3665L282.046 49.7167L285.697 46.0669L289.348 42.4171L292.999 38.7673L296.65 35.1175L300.301 31.4677L303.953 27.8179L304.58 27.1907C303.922 26.6081 303.239 26.077 302.53 25.5938L302.129 25.9947Z",
    fill: "#FFDE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M294.83 25.9949L291.179 29.6447L287.528 33.2945L283.877 36.9443L280.226 40.5941L276.575 44.2439L272.924 47.8937L271.203 49.6141C271.508 50.4846 271.871 51.3379 272.293 52.1706L274.748 49.7169L278.399 46.0671L282.05 42.4173L285.701 38.7675L289.352 35.1177L293.003 31.4679L296.654 27.8181L300.24 24.2334C299.407 23.8118 298.553 23.4451 297.682 23.1436L294.83 25.9949Z",
    fill: "#FFDE00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M291.182 22.3486L287.531 25.9984L283.88 29.6482L280.229 33.298L276.578 36.9478L272.927 40.5976L270.061 43.4626C270.082 44.0281 270.123 44.5901 270.185 45.1521C270.246 45.6833 270.329 46.2145 270.428 46.7423L271.1 46.0706L274.751 42.4208L278.402 38.771L282.053 35.1212L285.704 31.4714L289.355 27.8216L293.006 24.1718L294.809 22.3692C293.726 22.1601 292.629 22.0367 291.529 21.999L291.182 22.3452V22.3486Z",
    fill: "#FFDE00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282.512 23.7159L280.233 25.9948L276.582 29.6446L272.931 33.2945L271.782 34.4425C271.247 35.666 270.839 36.9271 270.551 38.2123C270.452 38.6646 270.366 39.1204 270.294 39.5762L271.103 38.7674L274.754 35.1176L278.405 31.4678L282.056 27.818L285.708 24.1682L287.648 22.2285C286.585 22.393 285.536 22.6363 284.504 22.9653C283.832 23.1812 283.167 23.428 282.512 23.7124V23.7159Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.245 47.1048C182.522 47.8279 182.512 48.9897 183.211 49.7265C183.801 48.695 184.332 47.6429 184.812 46.5702C184.253 46.4982 183.67 46.6764 183.242 47.1048H183.245Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.585 52.4241C179.852 51.6907 178.662 51.6907 177.925 52.4241C177.191 53.1575 177.191 54.3501 177.925 55.0835C178.237 55.3953 178.628 55.5735 179.036 55.6181C179.738 54.8059 180.403 53.9731 181.024 53.1163C180.931 52.8627 180.787 52.6263 180.585 52.4206V52.4241Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M175.264 57.7434C174.531 57.01 173.341 57.01 172.604 57.7434C171.871 58.4768 171.871 59.6694 172.604 60.4028C172.837 60.6358 173.118 60.7969 173.417 60.8792C174.233 60.2589 175.031 59.6009 175.806 58.9052C175.768 58.4802 175.587 58.0655 175.261 57.7434H175.264Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.944 63.0618C169.21 62.3284 168.021 62.3284 167.284 63.0618C166.79 63.5553 166.629 64.2509 166.8 64.8781C167.901 64.364 168.981 63.7917 170.037 63.1612C170.006 63.1269 169.978 63.0926 169.944 63.0618Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.021 32.5615C188.021 32.4653 188.028 32.3726 188.028 32.2764C188.017 32.3726 188.014 32.4653 188.021 32.5615Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M183.245 36.468C182.512 37.2014 182.512 38.394 183.245 39.1274C183.979 39.8608 185.172 39.8608 185.906 39.1274C186.639 38.394 186.639 37.2014 185.906 36.468C185.172 35.7346 183.982 35.7346 183.245 36.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.925 41.7873C177.191 42.5207 177.191 43.7133 177.925 44.4467C178.658 45.1801 179.852 45.1801 180.585 44.4467C181.319 43.7133 181.319 42.5207 180.585 41.7873C179.852 41.054 178.662 41.054 177.925 41.7873Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.604 47.1047C171.871 47.8381 171.871 49.0307 172.604 49.7641C173.338 50.4975 174.531 50.4975 175.264 49.7641C175.998 49.0307 175.998 47.8381 175.264 47.1047C174.531 46.3713 173.341 46.3713 172.604 47.1047Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M167.284 52.4241C166.55 53.1575 166.55 54.3501 167.284 55.0835C168.017 55.8168 169.21 55.8168 169.944 55.0835C170.678 54.3501 170.678 53.1575 169.944 52.4241C169.21 51.6907 168.021 51.6907 167.284 52.4241Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.963 57.7434C161.229 58.4768 161.229 59.6694 161.963 60.4028C162.697 61.1362 163.89 61.1362 164.623 60.4028C165.357 59.6694 165.357 58.4768 164.623 57.7434C163.89 57.01 162.7 57.01 161.963 57.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.643 63.0618C155.909 63.7951 155.909 64.9878 156.643 65.7212C157.376 66.4545 158.569 66.4545 159.303 65.7212C160.036 64.9878 160.036 63.7951 159.303 63.0618C158.566 62.3284 157.38 62.3284 156.643 63.0618Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M151.36 68.3464C152.186 68.343 153.016 68.3121 153.842 68.2504C153.115 67.6575 152.052 67.6884 151.36 68.3464Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.906 25.8303C185.172 25.0969 183.982 25.0969 183.245 25.8303C182.512 26.5637 182.512 27.7563 183.245 28.4897C183.979 29.2231 185.172 29.2231 185.906 28.4897C186.639 27.7563 186.639 26.5637 185.906 25.8303Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.585 31.1487C179.852 30.4153 178.662 30.4153 177.925 31.1487C177.191 31.8821 177.191 33.0747 177.925 33.8081C178.658 34.5415 179.852 34.5415 180.585 33.8081C181.319 33.0747 181.319 31.8821 180.585 31.1487Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.264 36.468C174.531 35.7346 173.341 35.7346 172.604 36.468C171.871 37.2014 171.871 38.394 172.604 39.1274C173.338 39.8608 174.531 39.8608 175.264 39.1274C175.998 38.394 175.998 37.2014 175.264 36.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.944 41.7873C169.21 41.054 168.021 41.054 167.284 41.7873C166.55 42.5207 166.55 43.7133 167.284 44.4467C168.017 45.1801 169.21 45.1801 169.944 44.4467C170.678 43.7133 170.678 42.5207 169.944 41.7873Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M164.623 47.1047C163.89 46.3713 162.7 46.3713 161.963 47.1047C161.229 47.8381 161.229 49.0307 161.963 49.7641C162.697 50.4975 163.89 50.4975 164.623 49.7641C165.357 49.0307 165.357 47.8381 164.623 47.1047Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M159.303 52.4241C158.566 51.6907 157.38 51.6907 156.643 52.4241C155.909 53.1575 155.909 54.3501 156.643 55.0835C157.376 55.8168 158.569 55.8168 159.303 55.0835C160.036 54.3501 160.036 53.1575 159.303 52.4241Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M151.322 57.7434C150.588 58.4768 150.588 59.6694 151.322 60.4028C152.059 61.1362 153.249 61.1362 153.982 60.4028C154.716 59.6694 154.716 58.4768 153.982 57.7434C153.249 57.01 152.059 57.01 151.322 57.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.001 63.0618C145.268 63.7951 145.268 64.9878 146.001 65.7212C146.735 66.4545 147.928 66.4545 148.662 65.7212C149.395 64.9878 149.395 63.7951 148.662 63.0618C147.928 62.3284 146.738 62.3284 146.001 63.0618Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M183.245 17.852C183.869 18.4757 184.819 18.5683 185.542 18.133C185.093 16.9781 184.586 15.8404 184.017 14.7266C183.736 14.8157 183.468 14.9699 183.245 15.1927C182.512 15.926 182.512 17.1186 183.245 17.852Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M180.585 20.512C179.852 19.7786 178.662 19.7786 177.925 20.512C177.191 21.2453 177.191 22.438 177.925 23.1713C178.658 23.9047 179.852 23.9047 180.585 23.1713C181.319 22.438 181.319 21.2453 180.585 20.512Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M175.264 25.8303C174.531 25.0969 173.341 25.0969 172.604 25.8303C171.871 26.5637 171.871 27.7563 172.604 28.4897C173.338 29.2231 174.531 29.2231 175.264 28.4897C175.998 27.7563 175.998 26.5637 175.264 25.8303Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M169.944 31.1487C169.21 30.4153 168.021 30.4153 167.284 31.1487C166.55 31.8821 166.55 33.0747 167.284 33.8081C168.017 34.5415 169.21 34.5415 169.944 33.8081C170.678 33.0747 170.678 31.8821 169.944 31.1487Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.623 36.468C163.89 35.7346 162.7 35.7346 161.963 36.468C161.229 37.2014 161.229 38.394 161.963 39.1274C162.697 39.8608 163.89 39.8608 164.623 39.1274C165.357 38.394 165.357 37.2014 164.623 36.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.303 41.7873C158.566 41.054 157.38 41.054 156.643 41.7873C155.909 42.5207 155.909 43.7133 156.643 44.4467C157.376 45.1801 158.569 45.1801 159.303 44.4467C160.036 43.7133 160.036 42.5207 159.303 41.7873Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M153.982 47.1047C153.249 46.3713 152.059 46.3713 151.322 47.1047C150.588 47.8381 150.588 49.0307 151.322 49.7641C152.059 50.4975 153.249 50.4975 153.982 49.7641C154.716 49.0307 154.716 47.8381 153.982 47.1047Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M148.662 52.4241C147.928 51.6907 146.738 51.6907 146.001 52.4241C145.268 53.1575 145.268 54.3501 146.001 55.0835C146.735 55.8168 147.928 55.8168 148.662 55.0835C149.395 54.3501 149.395 53.1575 148.662 52.4241Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M140.681 57.7434C139.947 58.4768 139.947 59.6694 140.681 60.4028C141.414 61.1362 142.607 61.1362 143.341 60.4028C144.075 59.6694 144.075 58.4768 143.341 57.7434C142.607 57.01 141.418 57.01 140.681 57.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M138.024 65.7212C138.758 64.9878 138.758 63.7951 138.024 63.0618C137.29 62.3284 136.101 62.3284 135.364 63.0618C134.956 63.4696 134.778 64.0145 134.819 64.5457C135.813 65.0357 136.824 65.4778 137.849 65.8719C137.911 65.8239 137.969 65.776 138.024 65.7177V65.7212Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M180.585 9.87426C179.852 9.14087 178.662 9.14087 177.925 9.87426C177.191 10.6076 177.191 11.8003 177.925 12.5337C178.658 13.267 179.852 13.267 180.585 12.5337C181.319 11.8003 181.319 10.6076 180.585 9.87426Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M175.264 15.1926C174.531 14.4592 173.341 14.4592 172.604 15.1926C171.871 15.926 171.871 17.1186 172.604 17.852C173.338 18.5854 174.531 18.5854 175.264 17.852C175.998 17.1186 175.998 15.926 175.264 15.1926Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M169.944 20.512C169.21 19.7786 168.021 19.7786 167.284 20.512C166.55 21.2453 166.55 22.438 167.284 23.1713C168.017 23.9047 169.21 23.9047 169.944 23.1713C170.678 22.438 170.678 21.2453 169.944 20.512Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M164.623 25.8303C163.89 25.0969 162.7 25.0969 161.963 25.8303C161.229 26.5637 161.229 27.7563 161.963 28.4897C162.697 29.2231 163.89 29.2231 164.623 28.4897C165.357 27.7563 165.357 26.5637 164.623 25.8303Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M159.303 31.1487C158.569 30.4153 157.38 30.4153 156.643 31.1487C155.909 31.8821 155.909 33.0747 156.643 33.8081C157.376 34.5415 158.569 34.5415 159.303 33.8081C160.036 33.0747 160.036 31.8821 159.303 31.1487Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M153.982 36.468C153.249 35.7346 152.059 35.7346 151.322 36.468C150.588 37.2014 150.588 38.394 151.322 39.1274C152.059 39.8608 153.249 39.8608 153.982 39.1274C154.716 38.394 154.716 37.2014 153.982 36.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M148.662 41.7873C147.928 41.054 146.738 41.054 146.001 41.7873C145.268 42.5207 145.268 43.7133 146.001 44.4467C146.735 45.1801 147.928 45.1801 148.662 44.4467C149.395 43.7133 149.395 42.5207 148.662 41.7873Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M143.341 47.1047C142.607 46.3713 141.418 46.3713 140.681 47.1047C139.947 47.8381 139.947 49.0307 140.681 49.7641C141.414 50.4975 142.607 50.4975 143.341 49.7641C144.075 49.0307 144.075 47.8381 143.341 47.1047Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M135.364 52.4241C134.63 53.1575 134.63 54.3501 135.364 55.0835C136.097 55.8168 137.287 55.8168 138.024 55.0835C138.758 54.3501 138.758 53.1575 138.024 52.4241C137.29 51.6907 136.101 51.6907 135.364 52.4241Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M130.04 57.7434C129.306 58.4768 129.306 59.6694 130.04 60.4028C130.773 61.1362 131.966 61.1362 132.7 60.4028C133.434 59.6694 133.434 58.4768 132.7 57.7434C131.966 57.01 130.777 57.01 130.04 57.7434Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M175.264 4.55492C174.531 3.82154 173.341 3.82154 172.604 4.55492C171.871 5.28831 171.871 6.48093 172.604 7.21432C173.338 7.9477 174.531 7.9477 175.264 7.21432C175.998 6.4775 175.998 5.28831 175.264 4.55492Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M169.944 9.87426C169.21 9.14087 168.021 9.14087 167.284 9.87426C166.55 10.6076 166.55 11.8003 167.284 12.5337C168.017 13.267 169.21 13.267 169.944 12.5337C170.678 11.8003 170.678 10.6076 169.944 9.87426Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M164.623 15.1926C163.89 14.4592 162.7 14.4592 161.963 15.1926C161.229 15.926 161.229 17.1186 161.963 17.852C162.697 18.5854 163.89 18.5854 164.623 17.852C165.357 17.1186 165.357 15.926 164.623 15.1926Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M159.303 20.512C158.569 19.7786 157.38 19.7786 156.643 20.512C155.909 21.2453 155.909 22.438 156.643 23.1713C157.376 23.9047 158.569 23.9047 159.303 23.1713C160.036 22.438 160.036 21.2453 159.303 20.512Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M153.982 25.8303C153.249 25.0969 152.059 25.0969 151.322 25.8303C150.588 26.5637 150.588 27.7563 151.322 28.4897C152.059 29.2231 153.249 29.2231 153.982 28.4897C154.716 27.7563 154.716 26.5637 153.982 25.8303Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M148.662 31.1487C147.928 30.4153 146.738 30.4153 146.001 31.1487C145.268 31.8821 145.268 33.0747 146.001 33.8081C146.735 34.5415 147.928 34.5415 148.662 33.8081C149.395 33.0747 149.395 31.8821 148.662 31.1487Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M143.341 36.468C142.608 35.7346 141.418 35.7346 140.681 36.468C139.944 37.2014 139.944 38.394 140.681 39.1274C141.414 39.8608 142.608 39.8608 143.341 39.1274C144.075 38.394 144.075 37.2014 143.341 36.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M138.021 41.7873C137.287 41.054 136.097 41.054 135.36 41.7873C134.627 42.5207 134.627 43.7133 135.36 44.4467C136.094 45.1801 137.284 45.1801 138.021 44.4467C138.754 43.7133 138.754 42.5207 138.021 41.7873Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M132.7 47.1047C131.966 46.3713 130.777 46.3713 130.04 47.1047C129.306 47.8381 129.306 49.0307 130.04 49.7641C130.773 50.4975 131.966 50.4975 132.7 49.7641C133.434 49.0307 133.434 47.8381 132.7 47.1047Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M124.719 52.4241C123.986 53.1575 123.986 54.3501 124.719 55.0835C125.453 55.8168 126.646 55.8168 127.379 55.0835C128.113 54.3501 128.113 53.1575 127.379 52.4241C126.646 51.6907 125.456 51.6907 124.719 52.4241Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M167.284 1.89848C168.017 2.63187 169.21 2.63187 169.944 1.89848C170.448 1.3947 170.606 0.671597 170.417 0.0341661C169.673 -0.421631 168.915 -0.850012 168.144 -1.25098C167.829 -1.16873 167.53 -1.00766 167.284 -0.760911C166.55 -0.0275232 166.55 1.16509 167.284 1.89848Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M164.623 4.55883C163.89 3.82544 162.7 3.82544 161.963 4.55883C161.229 5.29222 161.229 6.48483 161.963 7.21822C162.697 7.95161 163.89 7.95161 164.623 7.21822C165.357 6.48483 165.357 5.29222 164.623 4.55883Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M159.303 9.87426C158.569 9.14087 157.38 9.14087 156.643 9.87426C155.909 10.6076 155.909 11.8003 156.643 12.5337C157.376 13.267 158.569 13.267 159.303 12.5337C160.036 11.8003 160.036 10.6076 159.303 9.87426Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M153.982 15.1926C153.249 14.4592 152.059 14.4592 151.322 15.1926C150.588 15.926 150.588 17.1186 151.322 17.852C152.059 18.5854 153.249 18.5854 153.982 17.852C154.716 17.1186 154.716 15.926 153.982 15.1926Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M148.662 20.512C147.928 19.7786 146.738 19.7786 146.001 20.512C145.268 21.2453 145.268 22.438 146.001 23.1713C146.735 23.9047 147.928 23.9047 148.662 23.1713C149.395 22.438 149.395 21.2453 148.662 20.512Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M143.341 25.8303C142.608 25.0969 141.418 25.0969 140.681 25.8303C139.944 26.5637 139.944 27.7563 140.681 28.4897C141.414 29.2231 142.608 29.2231 143.341 28.4897C144.075 27.7563 144.075 26.5637 143.341 25.8303Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M138.021 31.1487C137.287 30.4153 136.097 30.4153 135.36 31.1487C134.627 31.8821 134.627 33.0747 135.36 33.8081C136.094 34.5415 137.284 34.5415 138.021 33.8081C138.754 33.0747 138.754 31.8821 138.021 31.1487Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M132.7 36.468C131.966 35.7346 130.777 35.7346 130.04 36.468C129.306 37.2014 129.306 38.394 130.04 39.1274C130.773 39.8608 131.966 39.8608 132.7 39.1274C133.434 38.394 133.434 37.2014 132.7 36.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M127.379 41.7873C126.646 41.054 125.456 41.054 124.719 41.7873C123.986 42.5207 123.986 43.7133 124.719 44.4467C125.453 45.1801 126.646 45.1801 127.379 44.4467C128.113 43.7133 128.113 42.5207 127.379 41.7873Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M119.402 47.1047C118.668 47.8381 118.668 49.0307 119.402 49.7641C120.136 50.4975 121.329 50.4975 122.062 49.7641C122.796 49.0307 122.796 47.8381 122.062 47.1047C121.329 46.3713 120.139 46.3713 119.402 47.1047Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M159.303 -0.759889C158.569 -1.4967 157.38 -1.4967 156.643 -0.759889C155.909 -0.0265007 155.909 1.16611 156.643 1.8995C157.376 2.63289 158.569 2.63289 159.303 1.8995C160.036 1.16611 160.036 -0.0265007 159.303 -0.759889Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M153.982 4.55883C153.249 3.82544 152.059 3.82544 151.322 4.55883C150.588 5.29222 150.588 6.48483 151.322 7.21822C152.059 7.95161 153.249 7.95161 153.982 7.21822C154.716 6.48483 154.716 5.29222 153.982 4.55883Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M148.662 9.87426C147.928 9.14087 146.738 9.14087 146.001 9.87426C145.268 10.6076 145.268 11.8003 146.001 12.5337C146.735 13.267 147.928 13.267 148.662 12.5337C149.395 11.8003 149.395 10.6076 148.662 9.87426Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M143.341 15.1926C142.608 14.4592 141.418 14.4592 140.681 15.1926C139.944 15.926 139.944 17.1186 140.681 17.852C141.414 18.5854 142.608 18.5854 143.341 17.852C144.075 17.1186 144.075 15.926 143.341 15.1926Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M138.021 20.512C137.287 19.7786 136.097 19.7786 135.36 20.512C134.627 21.2453 134.627 22.438 135.36 23.1713C136.094 23.9047 137.284 23.9047 138.021 23.1713C138.754 22.438 138.754 21.2453 138.021 20.512Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M132.7 25.8332C131.966 25.0999 130.777 25.0999 130.04 25.8332C129.306 26.5666 129.306 27.7592 130.04 28.4926C130.773 29.226 131.966 29.226 132.7 28.4926C133.434 27.7592 133.434 26.5666 132.7 25.8332Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M127.383 31.1487C126.649 30.4153 125.46 30.4153 124.723 31.1487C123.989 31.8821 123.989 33.0747 124.723 33.8081C125.456 34.5415 126.649 34.5415 127.383 33.8081C128.117 33.0747 128.117 31.8821 127.383 31.1487Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M122.059 36.468C121.325 35.7346 120.136 35.7346 119.399 36.468C118.665 37.2014 118.665 38.394 119.399 39.1274C120.132 39.8608 121.325 39.8608 122.059 39.1274C122.793 38.394 122.793 37.2014 122.059 36.468Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M116.742 41.7866C116.419 41.4645 116.008 41.2828 115.59 41.2451C115.892 42.3521 116.248 43.4453 116.656 44.5282C116.687 44.5008 116.714 44.4768 116.745 44.4494C117.479 43.716 117.479 42.5234 116.745 41.79L116.742 41.7866Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M148.662 -0.759889C147.928 -1.4967 146.738 -1.4967 146.001 -0.759889C145.268 -0.0265007 145.268 1.16611 146.001 1.8995C146.735 2.63289 147.928 2.63289 148.662 1.8995C149.395 1.16611 149.395 -0.0265007 148.662 -0.759889Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M143.341 4.55883C142.608 3.82544 141.418 3.82544 140.681 4.55883C139.944 5.29222 139.944 6.48483 140.681 7.21822C141.414 7.95161 142.608 7.95161 143.341 7.21822C144.075 6.48483 144.075 5.29222 143.341 4.55883Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M138.021 9.87719C137.287 9.1438 136.097 9.1438 135.36 9.87719C134.627 10.6106 134.627 11.8032 135.36 12.5366C136.094 13.27 137.284 13.27 138.021 12.5366C138.754 11.8032 138.754 10.6106 138.021 9.87719Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M132.7 15.1926C131.966 14.4592 130.777 14.4592 130.04 15.1926C129.306 15.926 129.306 17.1186 130.04 17.852C130.773 18.5854 131.966 18.5854 132.7 17.852C133.434 17.1186 133.434 15.926 132.7 15.1926Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M127.383 20.512C126.649 19.7786 125.46 19.7786 124.723 20.512C123.989 21.2453 123.989 22.438 124.723 23.1713C125.456 23.9047 126.649 23.9047 127.383 23.1713C128.117 22.438 128.117 21.2453 127.383 20.512Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M122.059 25.8332C121.325 25.0999 120.136 25.0999 119.399 25.8332C118.665 26.5666 118.665 27.7592 119.399 28.4926C120.132 29.226 121.325 29.226 122.059 28.4926C122.793 27.7592 122.793 26.5666 122.059 25.8332Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M116.742 31.1493C116.07 30.4776 115.021 30.4227 114.284 30.9779C114.27 31.9992 114.297 33.0239 114.366 34.0417C115.096 34.5318 116.097 34.453 116.742 33.8087C117.475 33.0753 117.475 31.8827 116.742 31.1493Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M138.021 -0.759889C137.287 -1.4967 136.097 -1.4967 135.36 -0.759889C134.627 -0.0265007 134.627 1.16611 135.36 1.8995C136.094 2.63289 137.284 2.63289 138.021 1.8995C138.754 1.16611 138.754 -0.0265007 138.021 -0.759889Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M132.703 4.55883C131.97 3.82544 130.78 3.82544 130.043 4.55883C129.31 5.29222 129.31 6.48483 130.043 7.21822C130.777 7.95161 131.97 7.95161 132.703 7.21822C133.437 6.48483 133.437 5.29222 132.703 4.55883Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M127.383 9.87719C126.649 9.1438 125.46 9.1438 124.723 9.87719C123.989 10.6106 123.989 11.8032 124.723 12.5366C125.456 13.27 126.649 13.27 127.383 12.5366C128.117 11.8032 128.117 10.6106 127.383 9.87719Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M122.059 15.1926C121.325 14.4592 120.136 14.4592 119.399 15.1926C118.665 15.926 118.665 17.1186 119.399 17.852C120.132 18.5854 121.325 18.5854 122.059 17.852C122.793 17.1186 122.793 15.926 122.059 15.1926Z",
    fill: "#67CFEE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M116.742 23.1708C117.475 22.4374 117.475 21.2448 116.742 20.5114C116.546 20.316 116.317 20.1755 116.077 20.083C115.693 21.2722 115.367 22.4785 115.106 23.6951C115.686 23.7911 116.296 23.6163 116.742 23.1708Z",
    fill: "#67CFEE"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M41.63 56.8554H41.1363C40.0564 56.8554 39.1754 55.9747 39.1754 54.8952V54.4017C39.1754 53.3221 40.0564 52.4414 41.1363 52.4414H41.63C42.7098 52.4414 43.5909 53.3221 43.5909 54.4017V54.8952C43.5909 55.9747 42.7098 56.8554 41.63 56.8554ZM32.3978 56.0878L32.2298 55.6217C31.8596 54.6073 30.7283 54.0795 29.717 54.4497L29.2507 54.6176C28.236 54.9877 27.708 56.1186 28.0783 57.1296L28.2463 57.5957C28.6165 58.6101 29.7478 59.1378 30.7591 58.7677L31.2254 58.5998C32.2401 58.2297 32.7681 57.0988 32.3978 56.0878ZM22.2881 61.0364L21.9692 60.656C21.2767 59.8301 20.0323 59.7205 19.2061 60.4127L18.8256 60.7314C17.9994 61.4237 17.8897 62.6677 18.5822 63.4936L18.901 63.874C19.5935 64.6999 20.8379 64.8096 21.6641 64.1173L22.0447 63.7986C22.8709 63.1064 22.9806 61.8623 22.2881 61.0364ZM14.482 69.1448L14.0535 68.8981C13.1176 68.36 11.9143 68.6822 11.3727 69.6143L11.1258 70.0427C10.5876 70.9783 10.9099 72.1812 11.8423 72.7226L12.2709 72.9694C13.2068 73.5075 14.4101 73.1853 14.9517 72.2531L15.1985 71.8248C15.7368 70.8892 15.4145 69.6863 14.482 69.1448ZM9.91911 79.4328L9.43231 79.3472C8.36956 79.1587 7.34796 79.8749 7.15941 80.9373L7.0737 81.4239C6.88515 82.4863 7.60165 83.5076 8.66439 83.6961L9.15119 83.7817C10.2139 83.9702 11.2355 83.254 11.4241 82.1916L11.5098 81.705C11.6983 80.6426 10.9819 79.6213 9.91911 79.4328ZM9.15119 90.6598L8.66439 90.7455C7.60165 90.934 6.88515 91.9553 7.0737 93.0176L7.15941 93.5043C7.34796 94.5666 8.36956 95.2829 9.43231 95.0944L9.91911 95.0087C10.9819 94.8203 11.6983 93.799 11.5098 92.7366L11.4241 92.25C11.2355 91.1876 10.2139 90.4713 9.15119 90.6598ZM12.2709 101.472L11.8423 101.719C10.9064 102.257 10.5842 103.463 11.1258 104.399L11.3727 104.827C11.9109 105.763 13.1176 106.085 14.0535 105.543L14.482 105.297C15.4179 104.759 15.7402 103.552 15.1985 102.617L14.9517 102.188C14.4135 101.253 13.2068 100.931 12.2709 101.472ZM18.901 110.564L18.5822 110.945C17.8897 111.77 17.9959 113.014 18.8256 113.707L19.2061 114.025C20.0323 114.718 21.2767 114.611 21.9692 113.782L22.2881 113.402C22.9806 112.576 22.8743 111.332 22.0447 110.639L21.6641 110.321C20.8379 109.629 19.5935 109.735 18.901 110.564ZM28.2428 116.842L28.0749 117.309C27.7046 118.323 28.2326 119.454 29.2473 119.821L29.7135 119.988C30.7283 120.359 31.8596 119.831 32.2264 118.816L32.3944 118.35C32.7646 117.336 32.2367 116.205 31.2219 115.838L30.7557 115.67C29.741 115.3 28.6097 115.828 28.2428 116.842ZM39.1685 119.546V120.04C39.1685 121.119 40.0496 122 41.1294 122H41.6231C42.703 122 43.584 121.119 43.584 120.04V119.546C43.584 118.467 42.703 117.586 41.6231 117.586H41.1294C40.0496 117.586 39.1685 118.467 39.1685 119.546ZM50.3616 118.354L50.5296 118.82C50.8998 119.834 52.0311 120.362 53.0424 119.992L53.5087 119.824C54.5234 119.454 55.0514 118.323 54.6811 117.312L54.5131 116.846C54.1429 115.831 53.0116 115.304 52.0003 115.674L51.534 115.842C50.5193 116.212 49.9913 117.343 50.3616 118.354ZM60.4713 113.405L60.7902 113.786C61.4827 114.611 62.7271 114.721 63.5533 114.029L63.9338 113.71C64.76 113.018 64.8697 111.774 64.1772 110.948L63.8584 110.568C63.1659 109.742 61.9215 109.632 61.0953 110.324L60.7148 110.643C59.8886 111.335 59.7789 112.579 60.4713 113.405ZM68.2774 105.297L68.7059 105.543C69.6418 106.082 70.8451 105.759 71.3867 104.827L71.6336 104.399C72.1718 103.463 71.8495 102.26 70.9171 101.719L70.4885 101.472C69.5527 100.934 68.3493 101.256 67.8077 102.188L67.5609 102.617C67.0226 103.552 67.3449 104.755 68.2774 105.297ZM72.8403 95.0087L73.3271 95.0944C74.3898 95.2829 75.4114 94.5666 75.6 93.5043L75.6857 93.0176C75.8743 91.9553 75.1578 90.934 74.095 90.7455L73.6082 90.6598C72.5455 90.4713 71.5239 91.1876 71.3353 92.25L71.2496 92.7366C71.0611 93.799 71.7776 94.8203 72.8403 95.0087ZM73.6082 83.7817L74.095 83.6961C75.1578 83.5076 75.8743 82.4863 75.6857 81.4239L75.6 80.9373C75.4114 79.8749 74.3898 79.1587 73.3271 79.3472L72.8403 79.4328C71.7776 79.6213 71.0611 80.6426 71.2496 81.705L71.3353 82.1916C71.5239 83.254 72.5455 83.9702 73.6082 83.7817ZM70.4885 72.9694L70.9171 72.7226C71.853 72.1846 72.1752 70.9783 71.6336 70.0427L71.3867 69.6143C70.8485 68.6787 69.6418 68.3566 68.7059 68.8981L68.2774 69.1448C67.3415 69.6829 67.0192 70.8892 67.5609 71.8248L67.8077 72.2531C68.3459 73.1887 69.5527 73.5109 70.4885 72.9694ZM63.8584 63.8775L64.1772 63.4971C64.8697 62.6711 64.7635 61.4271 63.9338 60.7348L63.5533 60.4162C62.7271 59.7239 61.4827 59.8301 60.7902 60.6595L60.4713 61.0399C59.7789 61.8658 59.8851 63.1098 60.7148 63.8021L61.0953 64.1208C61.9215 64.813 63.1659 64.7068 63.8584 63.8775ZM54.5166 57.5991L54.6845 57.133C55.0548 56.1186 54.5268 54.9877 53.5121 54.621L53.0459 54.4531C52.0311 54.083 50.8998 54.6107 50.533 55.6251L50.365 56.0912C49.9948 57.1056 50.5227 58.2365 51.5375 58.6032L52.0037 58.7712C53.0184 59.1413 54.1497 58.6135 54.5166 57.5991Z",
    fill: "#FFDE00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M340.316 -138.803C342.229 -136.969 342.294 -133.933 340.46 -132.021L168.947 46.8745C167.113 48.7868 164.076 48.8519 162.163 47.0184C160.25 45.1849 160.185 42.1486 162.019 40.2363L333.532 -138.659C335.366 -140.571 338.403 -140.636 340.316 -138.803ZM150.466 59.4243C152.375 61.2543 155.406 61.1892 157.236 59.2804C159.067 57.3715 159.002 54.342 157.092 52.5119C155.183 50.6819 152.152 50.747 150.322 52.6559C148.491 54.5647 148.556 57.5943 150.466 59.4243Z",
    fill: "#FFDE00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M170.884 80.1752C167.285 76.7242 167.161 71.0113 170.614 67.4095L493.348 -269.219C496.8 -272.817 502.515 -272.941 506.118 -269.49C509.717 -266.039 509.841 -260.326 506.389 -256.724L183.651 79.9045C180.199 83.5029 174.484 83.6263 170.881 80.1752H170.884Z",
    fill: "#67CFEE"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1218 42.9994C94.0335 42.9994 97.2045 39.8295 97.2045 35.9191C97.2045 32.0088 94.0335 28.8389 90.1218 28.8389C86.2102 28.8389 83.0392 32.0088 83.0392 35.9191C83.0392 39.8295 86.2102 42.9994 90.1218 42.9994Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M63.063 73.8841C71.8519 73.8841 78.9767 66.7617 78.9767 57.9757C78.9767 49.1898 71.8519 42.0674 63.063 42.0674C54.2741 42.0674 47.1493 49.1898 47.1493 57.9757C47.1493 66.7617 54.2741 73.8841 63.063 73.8841Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopSavedImage);
export default __webpack_public_path__ + "static/media/topSavedImage.f171a69f021680ee0dc32881e48ee229.svg";
export { ForwardRef as ReactComponent };